
// --------------------------------------------------------------------------------------
// ✅ Import Bootstrap (JavaScript Bundle)
// --------------------------------------------------------------------------------------
// Bootstrap provides responsive, mobile-first components and interactions via its JavaScript library.
// The 'bootstrap.bundle' includes Popper for tooltips, popovers, dropdowns, and other interactive components.
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
window.bootstrap = bootstrap; // Make Bootstrap globally accessible via 'window.bootstrap'

// --------------------------------------------------------------------------------------
// ✅ KYC action-button double-click guard (EPCH-404)
// --------------------------------------------------------------------------------------
// Static import (not routed through ./modules/index.js's dynamic import() barrel) —
// see resources/js/modules/_kyc_action_guard.js for why this must stay static.
import './modules/_kyc_action_guard.js';

// Replaces the inline onclick attributes the script policy would not run (W10-4).
import './modules/_link_actions.js';


// --------------------------------------------------------------------------------------
// ✅ Import jQuery
// --------------------------------------------------------------------------------------
// jQuery is a popular JavaScript library that simplifies HTML document traversal, manipulation,
// event handling, and AJAX interactions. It's useful for DOM manipulations and legacy support.
import $ from 'jquery';
window.$ = $;      // Make jQuery globally accessible via '$'
window.jQuery = $; // Ensure compatibility with plugins expecting 'jQuery'


// --------------------------------------------------------------------------------------
// ✅ Import Axios (HTTP Client)
// --------------------------------------------------------------------------------------
// Axios is a promise-based HTTP client for making requests to your backend. It supports
// automatic JSON data transformation, request/response interception, and error handling.
import axios from 'axios';
window.axios = axios; // Make Axios globally accessible via 'window.axios'

// Set default headers to ensure Laravel correctly identifies AJAX requests
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


// --------------------------------------------------------------------------------------
// ✅ Import IMask Phone Number Library
// --------------------------------------------------------------------------------------
// Imported for its side effect only: imask's ESM entry assigns globalThis.IMask,
// which is what components/forms/livewire/mobile-input.blade.php calls from Alpine's
// x-init. The binding below is deliberately unused — do not delete this import.
import 'imask';


// --------------------------------------------------------------------------------------
// ✅ Import Chart
// --------------------------------------------------------------------------------------
// 'chart.js/auto' registers every controller, scale, element and plugin Chart.js
// ships. The app draws exactly two charts — a filled line (leave-monetary-values)
// and a stacked bar (leave-usage) — so only their pieces are registered here. The
// Colors plugin is kept because 'auto' includes it and both charts would otherwise
// fall back to different defaults for any dataset that omits a colour.
import {
    Chart,
    BarController,
    BarElement,
    CategoryScale,
    Colors,
    Filler,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip,
} from 'chart.js';

Chart.register(
    BarController,
    BarElement,
    CategoryScale,
    Colors,
    Filler,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip,
);

window.Chart = Chart;


// --------------------------------------------------------------------------------------
// ✅ Import Flatpickr (Date inputs)
// --------------------------------------------------------------------------------------
import flatpickr from 'flatpickr';
window.flatpickr = flatpickr;


// --------------------------------------------------------------------------------------
// ✅ Import FullCalendar (calendar view)
// --------------------------------------------------------------------------------------
import { Calendar } from '@fullcalendar/core';
import timelinePlugin from '@fullcalendar/timeline';

// Expose FullCalendar components globally so they can be used inline in Blade
window.FullCalendar = {
    Calendar: Calendar,
    timeline: timelinePlugin,
};


// --------------------------------------------------------------------------------------
//   Importing JavaScript files responsible for CSS animations and visual effects
// --------------------------------------------------------------------------------------
// Contains modules handling animations like fade-ins, slide transitions, scroll-triggered animations, etc.
// Helps to maintain smooth and responsive user interactions throughout the application.
import './animations';


// --------------------------------------------------------------------------------------
//   Importing External Libraries or Plugins
// --------------------------------------------------------------------------------------
// Loads and initializes third-party libraries (e.g., Bootstrap JS, SplideJS, SweetAlert2, etc.).
// Centralized management of external dependencies, allowing for easy maintenance and upgrades.
import './plugins';


// --------------------------------------------------------------------------------------
//   Importing Custom Modular Scripts
// --------------------------------------------------------------------------------------
// Contains JavaScript files dedicated to various reusable UI components or features.
// Examples include: Navbar interactions, Footer behavior, Modal handling, Sliders, etc.
// Promotes a clean, modular approach to organizing scripts related to individual UI elements.
import './modules';


// --------------------------------------------------------------------------------------
//   Importing Page-Specific JavaScript
// --------------------------------------------------------------------------------------
// Organizes scripts unique to specific pages or sections (e.g., Home, About, Contact).
// Keeps page-specific logic isolated, making the application structure more maintainable and scalable.
import './pages';


// --------------------------------------------------------------------------------------
//   Other
// --------------------------------------------------------------------------------------
//
// ** utilities **
// Utilities Directory: Contains reusable helper functions and general-purpose scripts used
// throughout the application (e.g., formatters, validators, API handlers).
//
// ** mock **
// Mock Directory: Stores placeholder data and testing utilities for development purposes,
// enabling the simulation of API responses and frontend interactions.

// --------------------------------------------------------------------------------------
//   Main Message
// --------------------------------------------------------------------------------------
//
// Designed & Developed by CubeZoo
// PEOPLE. DIGITAL. SIMPLIFIED
console.log(
    `%cDesigned & Developed by CubeZoo\n%cPEOPLE.%cDIGITAL.%cSIMPLIFIED.`,
    'color: #94a3b8; font-size: 16px; font-weight: bold; margin-bottom: 4px;', // Style for "Designed & Developed by CubeZoo"
    'color: #fde047; font-size: 18px; font-weight: bold;',                     // Yellow for PEOPLE.
    'color: #4ade80; font-size: 18px; font-weight: bold;',                     // Green for DIGITAL.
    'color: #60a5fa; font-size: 18px; font-weight: bold;'                      // Blue for SIMPLIFIED.
);
//
// Tech Stack
//     Laravel: The PHP Framework for Web Artisans
//     HTML: Standard Markup Language for Web Pages
//     JavaScript: The Language of the Web
//     SCSS: CSS with Superpowers
console.groupCollapsed('%c Tech Stack',                    'color: #94a3b8; font-size: 14px; font-weight: normal;' );
console.log('%cLaravel: %cThe PHP Framework for Web Artisans',  'color: #fb503b; font-weight: bold;', 'color: #f8f8f2;' );
console.log('%cHTML: %cStandard Markup Language for Web Pages', 'color: #e34f26; font-weight: bold;', 'color: #f8f8f2;' );
console.log('%cJavaScript: %cThe Language of the Web',          'color: #f7df1e; font-weight: bold;', 'color: #f8f8f2;' );
console.log('%cSCSS: %cCSS with Superpowers',                   'color: #cf649a; font-weight: bold;', 'color: #f8f8f2;' );
console.groupEnd();
//
// Visit us: https://www.cubezoo.co.za
console.log(
    "%c🔗 Visit us: %chttps://www.cubezoo.co.za",
    'color: #7dd3fc; font-size: 12px; margin-top: 5px;',
    'color: #7dd3fc; font-size: 12px; text-decoration: underline;'
);
